export const randomNumber = (max) => {
  return Math.floor(Math.random() * max);
};
